import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { AddPermitRegister, AddPermitRegisterVariables } from "./__generated__/AddPermitRegister";
import { CORE_PERMIT_REGISTER_FIELDS } from "../fragments/PermitRegister";

const ADD_PERMIT_REGISTER = gql`
  ${CORE_PERMIT_REGISTER_FIELDS}
  mutation AddPermitRegister($title: String!, $description: String, $projectId: String!, $organizationId: String!, $permitTypeIds: [String!]) {
    addPermitRegister(input: { title: $title, description: $description, projectId: $projectId, organizationId: $organizationId, permitTypeIds: $permitTypeIds }) {
      register {
        ...CorePermitRegisterFields
      }
    }
  }
`;

export function useAddPermitRegister() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    AddPermitRegister,
    AddPermitRegisterVariables
  >(ADD_PERMIT_REGISTER, { errorPolicy: "all" });

  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
